import api from "../../api/api";

export const updatePermission = async (data) => {
    console.log(data)
    const response = await api.put("users/permissions/", data)
    return response.data
}


const getPermissionSlice = {updatePermission}

export default getPermissionSlice